import React, { useContext, useEffect, useState } from "react";
import {
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Pagination,
    Paper,
    Select,
    SelectChangeEvent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { MainContext, MainContextState } from "../../context/MainContext";
import { FileData } from "../../types/api/files";
import { useNotification } from "../../hooks/useNotification";
import { getFiles } from "../../api/filesAPI";
import CustomButton from "../../components/UI/CustomButton/CustomButton";
import { useParams } from "react-router-dom";
import CustomSnackbar from "../../components/UI/CustomSnackbar";
import Loader from "../../components/Loader/Loader";
import { createExportFile } from "../../api/exportAPI";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { format } from "date-fns";
import { ru } from "date-fns/locale";
import { BASE_IMG_URL } from "../../constants/mainAPI";

const ReportPage = () => {
    const { constants } = useContext<Partial<MainContextState>>(MainContext);
    const { id } = useParams();
    const [load, setLoad] = useState(false);
    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
    });
    const [userFiles, setUserFiles] = useState<Array<FileData>>();
    const { setNotification, setOpenSnackbar, notification, openSnackbar } = useNotification();
    const [type, setType] = useState("0");
    const [tagId, setTagId] = useState("43");

    const fetchUserFiles = () => {
        setLoad(true);
        getFiles(
            ({ data, last_page, current_page }) => {
                setUserFiles(data);
                setPagination({ ...pagination, last_page: last_page, current_page: current_page });
                setLoad(false);
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoad(false);
            },
            { page: pagination.current_page, tag_id: tagId, format: 0 },
        );
    };

    const createReport = () => {
        setLoad(true);
        createExportFile(
            {
                type: Number(type),
                ids: [Number(id)],
            },
            () => {
                fetchUserFiles();
                setNotification({
                    severity: "success",
                    message: "Отчет сформирован успешно",
                });
                setOpenSnackbar(true);
                setLoad(false);
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setOpenSnackbar(true);
                setLoad(false);
            },
        );
    };
    useEffect(() => {
        fetchUserFiles();
    }, [pagination.current_page]);

    return (
        <div className={"container"}>
            <div className={"pageHeader"}>Карточки и список продуктов</div>
            <div
                style={{
                    display: "flex",
                    gridGap: "10px",
                    alignItems: "center",
                }}>
                <FormControl
                    sx={{
                        marginTop: "16px",
                        marginBottom: "8px",
                        width: "360px",
                    }}>
                    <InputLabel id={"resident-type-label"}>Тип отчета</InputLabel>
                    <Select
                        size={"small"}
                        labelId={"report-type"}
                        label={"Тип отчета"}
                        onChange={(event: SelectChangeEvent) => {
                            setType(event.target.value);
                            setTagId(Number(event.target.value) === 0 ? "43" : "44");
                        }}
                        value={type}>
                        {/* TODO: Костыл чтобы дергать только карточку и списки продуктов */}
                        {constants?.export_type.slice(0, 2).map(type => (
                            <MenuItem key={type.value} value={type.value}>
                                {type.text}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <CustomButton
                    sx={{
                        marginTop: "4px",
                    }}
                    onClick={fetchUserFiles}>
                    Поиск
                </CustomButton>
                <CustomButton
                    sx={{
                        marginTop: "4px",
                    }}
                    onClick={createReport}>
                    Сформировать отчет
                </CustomButton>
            </div>

            <TableContainer component={Paper} sx={{ marginBottom: "80px" }}>
                <Table
                    aria-label="report table"
                    sx={{
                        "& td": { border: "none" },
                    }}>
                    <TableHead sx={{ "& th": { fontSize: "16px", fontWeight: 700 } }}>
                        <TableRow>
                            <TableCell>Название</TableCell>
                            <TableCell align="center">Дата формирования</TableCell>
                            <TableCell align="center">Скачать</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {userFiles?.map(({ id, name, path, created_at }) => (
                            <TableRow key={id} sx={{ border: 0 }}>
                                <TableCell sx={{ wordWrap: "break-word" }}>{name}</TableCell>
                                <TableCell align="center">
                                    {format(new Date(created_at), "dd.MM.yyyy HH:mm", { locale: ru })}
                                </TableCell>
                                <TableCell align="center">
                                    <IconButton
                                        aria-label="download-icon"
                                        size="small"
                                        href={`${BASE_IMG_URL}/${path}`}>
                                        <FileDownloadIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className={"posBR"}>
                <div className={"paginationContainer"}>
                    <Pagination
                        onChange={(index, qwerty) => setPagination({ ...pagination, current_page: qwerty })}
                        page={pagination.current_page}
                        count={pagination.last_page}
                        shape="rounded"
                    />
                </div>
            </div>
            <CustomSnackbar openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} notification={notification} />
            <Loader backDrop open={load} />
        </div>
    );
};

export default ReportPage;
